import { ComponentType } from '@angular/cdk/portal';

export interface DrawerConfig<D = any> {
    /** Component to render inside the drawer */
    component?: ComponentType<any>;

    /** Data to pass to the component */
    data?: D;

    /** Width of the drawer */
    width?: string;

    /** Whether the drawer can be closed by clicking the backdrop */
    disableClose?: boolean;

    /** Whether to show the backdrop */
    hasBackdrop?: boolean;

    /** Custom CSS class for the drawer panel */
    panelClass?: string | string[];

    /** Position of the drawer */
    position?: 'left' | 'right';

    /** Whether to show close button */
    showCloseButton?: boolean;

    /** Title of the drawer */
    title?: string;
}

export class DrawerConfigDefaults {
    static readonly defaults: DrawerConfig = {
        width: '600px',
        disableClose: false,
        hasBackdrop: true,
        position: 'right',
        showCloseButton: true,
        panelClass: '',
    };
}
